<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form :form="form" layout="inline" :labelCol="{ style: { width: '70px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="计划名称" :help="null">
              <global-select
                v-decorator="['planName', { rules: [{ required: true }] }]"
                requestApi="/scp/scpMrpPlans/planNameBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ dataType: 2 }"
                :allowClear="false"
                @change="onChangePlan"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="计划版本" :help="null">
              <global-select
                ref="planVersionSelectRef"
                v-decorator="['planVersion', { rules: [{ required: true }] }]"
                selectType="selectAssembleSearch"
                requestApi="/scp/scpMrpPlans/planVersionBox"
                :selectItem="{ value: 'realValue', label: 'label', thirdLabel: 'bringOutDataOne', thirdLabelText: '最新版本' }"
                :setParams="{ dataType: 2, planName: form.getFieldsValue().planName }"
                :defaultActiveFirstOption="defaultActiveFirstOption"
                searchParam="planVersion"
                :allowClear="false"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="组织">
              <global-select
                v-decorator="['organizationCode', { initialValue: organizationCodeOrigin }]"
                requestApi="/scp/scpMrpPlans/planOrganizationBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ dataType: 2, planName: form.getFieldsValue().planName, planVersion: form.getFieldsValue().planVersion }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="计划员">
              <global-select
                v-decorator="['plannerCodeList']"
                selectType="selectMultiple"
                requestApi="/system/user/allJobCodeName"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="物料编码">
              <global-select
                v-decorator="['itemIdList']"
                selectType="selectMultipleSearch"
                :focusGet="true"
                :selectData="itemIdListData"
                :dropdown-match-select-width="false"
                requestApi="/scp/scpMrpSystemItems/planItemsBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ planName: form.getFieldsValue().planName, planVersion: form.getFieldsValue().planVersion, organizationCode: form.getFieldsValue().organizationCode }"
                searchParam="label"
                sourseField="res"
                :totalNum="9999999999"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="物料类别">
              <a-tree-select
                v-decorator="['categoryIdList']"
                :dropdown-style="{
                  maxHeight: '50vh'
                }"
                :tree-data="treeData"
                :max-tag-count="1"
                :replaceFields="{children: 'child', title: 'name', key: 'segment', value: 'id' }"
                tree-checkable
                allow-clear
                tree-node-filter-prop="title"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <download-modal :apiFun="apiScpMrpSystemItemsNewExport" ref="download" />
      <a-button @click="handleExport" v-hasPermi="['scp:scpMrpSystemItems:export']">导出</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 2800 }"
        >
          <template v-for="item in columns" :slot="item.dataIndex" slot-scope="{ text, record }">
            <div :key="item.dataIndex">
              <span v-if="item.dataIndex === 'operation'">
                <a @click="goNextPage('BOM组件', record)">BOM组件</a>
                <a @click="goNextPage('使用处', record)" class="ml10">使用处</a>
                <a @click="goNextPage('来源', record)" class="ml10">来源</a>
                <a @click="goNextPage('供应/需求', record)" class="ml10">供应/需求</a>
              </span>
              <span v-else-if="item.type === 'switch'">
                <a-switch :disabled="true" :checked="record[item.dataIndex] === 'Y'" />
              </span>
              <span v-else>{{ text }}</span>
            </div>
          </template>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { apiScpMrpSystemItemsList, apiScpMrpCategoryCodeCategoryBox, apiScpMrpSystemItemsNewExport } from '@/api/scp/mrp-result-query/query-materials'
import { generateLsTableResData } from '@/utils/util.js';
import DownloadModal from '@/views/components/download-modal/download-modal.vue'

export default {
  // eslint-disable-next-line
  name: 'Query-materials', // name要和rms配置菜单路由保存一致(首字母大写)
  components: { DownloadModal },
  data () {
    return {
      defaultActiveFirstOption: false,
      apiScpMrpSystemItemsNewExport,
       // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiScpMrpSystemItemsList, true),
        pageCurrent: true
      },
      // 控制搜索展开
      advanced: true,
      // 查询参数
      form: this.$form.createForm(this),
      // 表格数据
      tableList: [],
      // 表格字段
      columns: [
        {
          title: '组织',
          dataIndex: 'organizationName',
          align: 'center',
          width: 140,
          ellipsis: true,
          fixed: 'left'
        },
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          align: 'center',
          width: 140,
          ellipsis: true,
          fixed: 'left'
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          align: 'center',
          ellipsis: true
        },
        {
          title: '规格描述',
          dataIndex: 'specification',
          align: 'center',
          ellipsis: true
        },
        {
          title: '单位',
          dataIndex: 'primaryUom',
          align: 'center'
        },
        {
          title: '计划方法',
          dataIndex: 'planningCodeName',
          align: 'center'
        },
        {
          title: '制造/采购',
          dataIndex: 'planningMakeBuyCodeName',
          align: 'center'
        },
        {
          title: '最大订单量',
          dataIndex: 'maximumOrderQuantity',
          align: 'center'
        },
        {
          title: '最小订单量',
          dataIndex: 'minimumOrderQuantity',
          align: 'center'
        },
        {
          title: '最小包装量',
          dataIndex: 'fixedLotMultiplier',
          align: 'center'
        },
        {
          title: '预处理LT',
          dataIndex: 'preprocessingLeadTime',
          align: 'center'
        },
        {
          title: '采购LT',
          dataIndex: 'purchasingLeadTime',
          align: 'center'
        },
        {
          title: '后处理LT',
          dataIndex: 'postprocessingLeadTime',
          align: 'center'
        },
        {
          title: '固定LT',
          dataIndex: 'fixedLeadTime',
          align: 'center'
        },
        {
          title: '可变LT',
          dataIndex: 'variableLeadTime',
          align: 'center'
        },
        {
          title: '备库LT',
          dataIndex: 'safetyStockLeadTime',
          align: 'center'
        },
        {
          title: '计划员',
          dataIndex: 'realName',
          align: 'center'
        },
        {
          title: '舍入订单量',
          dataIndex: 'roundingControlType',
          scopedSlots: { customRender: 'roundingControlType' },
          align: 'center',
          type: "switch"
        },
        {
          title: '备料分类',
          dataIndex: 'deliveryTypeName',
          align: 'center'
        },
        {
          title: 'WIP供应类型',
          dataIndex: 'wipSupplyTypeName',
          align: 'center',
          ellipsis: true
        },
        {
          title: '计划版本',
          dataIndex: 'planVersion',
          align: 'center'
        },
        {
          title: '计划名称',
          dataIndex: 'planName',
          align: 'center'
        },
        {
          title: '操作',
          width: 240,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right'
        }
      ],
      treeData: [], // 物料类别
      itemIdListData: [] // 物料编码
    }
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  watch: {
    // 菜单和查询物料两个入口
    $route (to, from) {
      if (to.name !== "Query-materials") {
        return
      }
      if (Object.keys(this.$route.query).length > 0) {
        this.goNextHandle()
      } else {
        this.$nextTick(() => {
          this.form.resetFields()
        })
      }
    }
  },
  created () {
    // 从查询物料页面跳转过来，带过来的数据自动填充
    if (Object.keys(this.$route.query).length > 0) {
      this.goNextHandle()
    }
  },
  mounted () {
    this.getSearchAllScheme()
  },
  methods: {
    // 变化计划名称，清除计划版本,默认选中第一条
    onChangePlan(val) {
      this.form.setFieldsValue({ planVersion: '' })
      this.defaultActiveFirstOption = false;
      if (val && this.$refs?.planVersionSelectRef) {
        this.defaultActiveFirstOption = true;
        this.$refs.planVersionSelectRef.isInit = true;
      }
    },
    goNextHandle () {
      const obj = JSON.parse(this.$route.query.data)
      const arr = []
      const arr2 = []
      const arr3 = [{ realValue: "", label: "" }]
      obj.plannerCode && arr.push(obj.plannerCode)
      obj.itemId && arr2.push(obj.itemId)
      obj.plannerCodeList = arr
      obj.itemIdList = arr2
      arr3[0].realValue = obj.itemId
      arr3[0].label = obj.itemCode
      this.itemIdListData = arr3
      this.$nextTick(() => {
        this.form.setFieldsValue({
          planName: obj.planName,
          planVersion: obj.planVersion,
          organizationCode: obj.organizationCode,
          plannerCodeList: obj.plannerCodeList,
          itemIdList: obj.itemIdList
        })
        this.onSearch()
      })
    },
    goNextPage (val, record) {
      if (val === "BOM组件") {
        this.$router.push({ name: "Bom-assembly", query: { data: JSON.stringify(record) } })
      }
      if (val === "使用处") {
        this.$router.push({ name: "Matter-use-place", query: { data: JSON.stringify(record) } })
      }
      if (val === "来源") {
        this.$router.push({ name: "Matter-source", query: { data: JSON.stringify(record) } })
      }
      if (val === "供应/需求") {
        this.$router.push({ name: "Supply-demand", query: { data: JSON.stringify(record) } })
      }
    },
    // 物料类别-下拉框数据
    getSearchAllScheme () {
      apiScpMrpCategoryCodeCategoryBox({ parameterCode: "SCP_ITEM_CATEGORY", parameterLevelCode: "GLOBAL" }).then(res => {
        if (res.data && res.data.length > 0) {
          this.treeData = res.data
        }
      })
    },
    // 表单搜索
    onSearch () {
      if (!this.form.getFieldsValue().planName) {
        this.$message.warning('计划名称不能为空')
        return;
      }
      if (!this.form.getFieldsValue().planVersion) {
        this.$message.warning('计划版本不能为空')
        return;
      }
      this.$refs.dataTable.searchParams = this.form.getFieldsValue();
      this.$refs.dataTable.getData();
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.form.resetFields()
      this.handleQuery()
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 导出按钮操作 */
    handleExport () {
      const params = this.form.getFieldsValue()
      this.$refs.download.openModal(params)
      // this.download('scp/scpMrpSystemItems/export', {
      //   ...this.form.getFieldsValue()
      // }, `查询物料_${new Date().getTime()}.xlsx`)
    }
  }
}
</script>

<style scoped lang="less">
</style>
